module.exports = __webpack_public_path__ + "img/equipment.42b50842.png";